import React, { useEffect, useState } from 'react';
import { Button, Popconfirm, Space, Switch, Table, Tag, Tooltip } from 'antd';
import ModalViewKey from './Modal/ViewKey';
import { useDispatch } from 'react-redux';
import { autoRenewKeyRequest, deleteKeysRequest, getKeysRequest, renewKeyRequest } from '../../../Stores/KeySlice';
import { toast } from 'react-toastify';
import './styles.css';
import ExtendKeyModal from './Modal/ExtendKey';
import FilterInfoModal from './Modal/FilterInfo';

const TableComponent = ({ keyData, cyclesData,
    cyclesFillterData, statusFillterData, searchData, lang
}) => {
    const [data, setData] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [keyView, setKeyView] = useState({});
    const dispatch = useDispatch();
    const [dataFilter, setDataFilter] = useState([])
    const [isLoading, setIsLoading] = useState(true);
    // Extend Pack Modal
    const [extendPackRecord, setExtendPackRecord] = useState({});
    const [isOpenExtendPack, setIsOpenExtendPack] = useState(false);

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([])

    const [openModalFilterInfo, setOpenModalFilterInfo] = useState(false);

    useEffect(() => {
        if (keyData && cyclesData) {
            const mapCycles = {}
            cyclesData.map((data) => {
                mapCycles[data.id] = {
                    name: data.name,
                    price: data.price,
                }
            })

            const updatedKeyData = keyData.map((key) => ({
                ...key,
                cycle_data: mapCycles[key.cycle_id]
            }));

            // console.log(updatedKeyData)
            setData(updatedKeyData)
            setDataFilter(updatedKeyData)
            setIsLoading(false)
        }
    }, [keyData, cyclesData])

    useEffect(() => {
        // Filter
        let updatedKeyData = [...data]
        // updatedKeyData = updatedKeyData.filter((key) =>
        //     cyclesFillterData.some(cycle => cycle.id == key.cycle_id)
        // )

        statusFillterData.map((filter) => {
            updatedKeyData = updatedKeyData.filter((key) => {
                if (key.status == filter.status) {
                    return true
                }
            })
        })

        updatedKeyData = updatedKeyData.filter((key) => {
            if (searchData && key.cycle_data) {
                if (key.cycle_data.name.indexOf(searchData) !== -1) {
                    return true
                }
                if (key.id.indexOf(searchData) !== -1) {
                    return true
                }
            }
            if (!searchData) {
                return true
            }
        })

        setDataFilter(updatedKeyData)
    }, [cyclesFillterData, statusFillterData, searchData])

    const onClickView = (id) => {
        setKeyView(id)
        setIsModalOpen(true)
    }

    const onDelete = (id) => {
        setIsLoading(true)
        dispatch(deleteKeysRequest(id)).then((response) => {
            dispatch(getKeysRequest())
        });
    }

    const onExtendPack = (record) => {
        setIsOpenExtendPack(true)
        setExtendPackRecord(record)
    }

    const onCloseExtendPack = () => {
        setIsOpenExtendPack(false)
    }

    const onActAutoRenew = (record, value) => {
        dispatch(autoRenewKeyRequest({
            keyID: record.id,
            auto_renew: value
        })).then((response) => {
            dispatch(getKeysRequest())
        });
    }

    const columnsData = [
        {
            title: lang.created_at || 'Ngày tạo',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text) => <p>{text}</p>,
        },
        {
            title: lang.package || 'Gói',
            dataIndex: 'package',
            key: 'package',
            render: (_, record) => {
                return record.package_name && <p>{record.package_name}</p>
            },

        },
        {
            title: lang.cycle || 'Chu kỳ',
            dataIndex: 'cycle',
            key: 'cycle',
            render: (_, record) => {
                return record.cycle_data && <p>{record.cycle_data.name}</p>
            },

        },
        {
            title: lang.value || 'Giá trị',
            dataIndex: 'value',
            key: 'value',
            width: 200,
            render: (_, record) => {
                return <Tooltip placement="top" title={"Copy"}>
                    <a onClick={() => {
                        navigator.clipboard.writeText(record.id)
                        toast.success(<div>Copied key! <br /> {record.id} </div>, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    }}>{record.id}</a>
                </Tooltip>
            },
        },
        {
            title: lang.expired_at || 'Hết hoạt động lúc',
            dataIndex: 'end_date',
            key: 'end_date',
        },
        // {
        //     title: lang.vendor || 'Vendor',
        //     dataIndex: 'vendor',
        //     key: 'vendor',
        //     render: (_, record) => {
        //         return record.vendor ? <p>{record.vendor.toUpperCase()}</p> : <p>None</p>
        //     },
        // },
        {
            title: lang.status || 'Trạng thái',
            dataIndex: 'status',
            key: 'status',
            render: (status) => status ? (lang.status_label_true || "Đang hoạt động") : (lang.status_label_false || "Hết hạn"),
        },
        {
            title: lang.expiry || 'Thời hạn',
            dataIndex: 'day_left',
            key: 'day_left',
            render: (_, record) => {
                if (record.day_left) {
                    return <p>{record.day_left} {lang.day_left || "Day Left"}</p>
                }
            },
        },
        {
            title: lang.auto_renew || 'Tự động gia hạn',
            dataIndex: 'auto_renew',
            key: 'auto_renew',
            render: (_, record) => {
                return <Switch onChange={(value) => onActAutoRenew(record, value)} checked={record.auto_renew}></Switch>
            }
        },
        {
            title: lang.action || 'Hành động',
            key: 'action',
            width: 200,
            render: (_, record) => (
                <Space size="middle">
                    {(record.status && record.package_type != "pc") && (<a onClick={() => onClickView(record)}>{lang.view || 'View'}</a>)}
                    {!record.status && (<a onClick={() => onExtendPack(record)}>{lang.renew || 'Renew'}</a>)}
                    <a onClick={() => onDelete(record.id)}>{lang.delete || "Delete"}</a>
                </Space>
            ),
        }
    ];

    const rowSelection = {
        type: "checkbox",
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
            setSelectedRows(selectedRows)
        },
    };

    const onExtendMulti = () => {
        selectedRows.forEach(keyObj => {
            dispatch(renewKeyRequest({
                key_id: keyObj.id,
                cycle_id: keyObj.cycle_id,
                quantity: 1,
            })).then((response) => {
                setSelectedRowKeys([]);
                setSelectedRows([])
                dispatch(getKeysRequest())
            });
        });
    }

    const onDeleteMulti = () => {
        setIsLoading(true)
        selectedRows.forEach(keyObj => {
            dispatch(deleteKeysRequest(keyObj.id)).then((response) => {
                setSelectedRowKeys([]);
                setSelectedRows([])
                dispatch(getKeysRequest())
            });
        });
    }

    const onFilterInfoProxy = (data_find) => {
        if(data_find == -1) {
            setDataFilter(data);
            setOpenModalFilterInfo(false)
            return;
        }
        let inputProxies = data_find
            .split("\n")
            .map(line => line.trim())
            .filter(line => line);

        inputProxies = inputProxies.map(line => line.split(":")[0])
        
        const matched = data.filter(item => {
            return inputProxies.some(inputProxy => {
                let inputUsername = null;
                let inputPassword = null;
                
                // Check if input contains colon (proxy format)
                if (inputProxy.includes(':')) {
                    // Format 1: user:pass@ip:port
                    if (inputProxy.includes('@')) {
                        const [userPass, ipPort] = inputProxy.split('@');
                        if (userPass.includes(':')) {
                            const userPassParts = userPass.split(':');
                            inputUsername = userPassParts[0];
                            inputPassword = userPassParts[1];
                        }
                    }
                    // Format 2: ip:port:user:pass
                    else {
                        const parts = inputProxy.split(':');
                        if (parts.length >= 4) {
                            // Extract username and password from input (positions 2 and 3)
                            inputUsername = parts[2];
                            inputPassword = parts[3];
                        }
                    }

                    // If we found username and password, compare them
                    if (inputUsername && inputPassword) {
                        return item.username === inputUsername && item.password === inputPassword;
                    }
                }

                // Check if input is a UUID format
                const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
                if (uuidRegex.test(inputProxy)) {

                    // Match UUID exactly
                    return item.id && item.id.toLowerCase() === inputProxy.toLowerCase();
                }

                // Check if input is a partial UUID (without dashes)
                const uuidWithoutDashes = /^[0-9a-f]{32}$/i;
                if (uuidWithoutDashes.test(inputProxy)) {
                    // Convert to UUID format and compare
                    const formattedUuid = inputProxy.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5');
                    return item.id && item.id.toLowerCase() === formattedUuid.toLowerCase();
                }

                // Check for partial UUID match (contains the input)
                if (item.id && item.id.toLowerCase().includes(inputProxy.toLowerCase())) {
                    return true;
                }

                // Fallback: check if input matches username, password, or ID directly
                return item.username === inputProxy || 
                       item.password === inputProxy || 
                       (item.id && item.id.toString() === inputProxy);
            });
        });
        setDataFilter(matched);
        setOpenModalFilterInfo(false)
    }

    return <>
        <Table
            rowKey={'id'}
            columns={columnsData}
            dataSource={dataFilter}
            rowClassName={(record) => (record.status ? '' : 'inactive-row')}
            loading={isLoading}
            rowSelection={rowSelection}
            title={() => <>
                <div className="relative p-2">
                    <Button style={{height: "38px"}} onClick={() => setOpenModalFilterInfo(true)}>&#xe138; Filter Info</Button>
                </div>
                {rowSelection ? <div className="w-full flex items-center mb-3 mt-1 pl-3 h-4">
                    {lang.selected ? lang.selected : "Selected"}: {selectedRows.length} {selectedRows.length > 0 ? "Key" : ""} || <> </>
                    {selectedRows.length ? <Space style={{ marginLeft: '10px' }}>
                        <Button
                            key={1}
                            style={{ color: "green", borderColor: "green", marginRight: '8px' }}
                            onClick={onExtendMulti}
                        >
                            {lang.extend_btn ? lang.extend_btn : "Extend"}
                        </Button>
                        <Popconfirm
                            title="Confirm"
                            description="Are you sure?"
                            onConfirm={onDeleteMulti}
                        >
                            <Button
                                key={2}
                                style={{ color: "red", borderColor: "red", marginRight: '8px' }}
                            >
                                Delete
                            </Button>
                        </Popconfirm>
                    </Space> : ""}
                </div> : ""}
            </>}
        />
        <ModalViewKey
            keyView={keyView}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            lang={lang}
        />
        <ExtendKeyModal
            isOpen={isOpenExtendPack}
            onClose={onCloseExtendPack}
            record={extendPackRecord}
        />

        <FilterInfoModal
            isOpen={openModalFilterInfo}
            handleCancel={() => setOpenModalFilterInfo(false)}
            onSearch={onFilterInfoProxy}
        />
    </>
};

export default TableComponent;